import { render, staticRenderFns } from "./InventoryInEdit.vue?vue&type=template&id=5723f628&"
import script from "./InventoryInEdit.vue?vue&type=script&lang=js&"
export * from "./InventoryInEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports